<div class="gms-container">
    <div class="navigation-area">
        <app-infopost-sidebar-nav [menuItemType]="menuItemType"></app-infopost-sidebar-nav>
    </div>
    <div class="vertical-content-container">
        @if(!noHeader){
            <div class="header-area">
                <app-header [title]="title"><ng-content select="app-infopost-tsp-selector"></ng-content></app-header>
            </div>
        }

        @if(!(hideActions || ((areFilteredErrors$ | async) && shouldShowErrorPanel))) {
            <div class="processing-actions-area" [ngStyle]="{'height': processingActionsHeight,'padding': processingActionsPadding}">
                  <ng-content select="processing-actions-left"></ng-content>
                  <ng-content select="processing-actions-right"></ng-content>
              </div>
        }
        <div>
            <ng-content select="view-header"></ng-content>
        </div>
        <div [ngClass]="contentArea" (scroll)="onScroll ? onScroll($event) : null">
            @if(!((areFilteredErrors$ | async) && shouldShowErrorPanel)){
                <gms-loading-spinner [loading$]="contentLoading$"></gms-loading-spinner>
            }

            @if(shouldShowErrorPanel && (areFilteredErrors$ | async)){
                <gms-error-and-notice-panel [mainMessage]="errorPanelMainMessage" [subMessage]="errorPanelSubMessage" 
                    [iconClass]="errorPanelIconClass" [showReloadButton]="shouldShowErrorPanelButton"></gms-error-and-notice-panel>
            } @else{
                <ng-content select="view-body"></ng-content>
            }

        </div>
        <footer>
            <span class="footer-text">Copyright ©{{currentYear}} Boardwalk Pipeline Partners, LP</span>
        </footer>
    </div>
</div>